import { Filter } from '../common/types/calendar'

export type Row = {
  equipment_id: string
  name: string
}

function isEmpty(obj:Row[]){
  return !Object.keys(obj).length;
}

export const convertColumns = (rows: Row[]): Filter[] => {
  if(isEmpty(rows)){
    rows = [];
  }
  return rows.map((row: Row) => {
    return {
      id: row.equipment_id,
      name: row.name,
    }
  })
}
